import React, { createContext, useContext, useState, useCallback } from 'react';
import { detectLanguage, getTranslations, persistLanguage } from './translations';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectLanguage);
  // #1107 — write-through to localStorage so the choice survives a
  // refresh / direct load of /signup, not just in-app navigation.
  const setLang = useCallback((next) => {
    persistLanguage(next);
    setLangState(next);
  }, []);
  const t = getTranslations(lang);
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}

/**
 * #441 Phase 2 — substitute {key}-style placeholders in a translation
 * string. Used by tablet components that need to inject runtime
 * values (companion name, count, etc.) into translated text without
 * hand-rolling template logic per call site.
 *
 * Example:
 *   formatString('{name} — {count} tiles', { name: 'Berta', count: 5 })
 *   → 'Berta — 5 tiles'
 *
 * Missing keys leave the placeholder verbatim — better than crashing
 * if a translator forgot to keep the placeholder name aligned.
 */
export function formatString(template, vars) {
  if (!template) return '';
  if (!vars) return template;
  return template.replace(/\{([a-zA-Z0-9_]+)\}/g, (m, k) => {
    return vars[k] !== undefined ? String(vars[k]) : m;
  });
}
